export const FIELD_TYPES = [
    { label: "Text", value: 0 },
    { label: "Datum", value: 1 },
    { label: "Ja/Nej", value: 2 },
    { label: "Uppslag (lookup)", value: 3 },
];

export const UI_CONTROLS = [
    { label: "Textfält", value: 0 },
    { label: "Datumväljare", value: 1 },
    { label: "Kryssruta", value: 2 },
    { label: "Dropdown", value: 3 },
    { label: "Uppslag", value: 4 },
];
